import React, { ForwardedRef, useRef } from 'react'
import { Col, Container, Row } from "reactstrap"
import Navbar from "../../components/Navbar"
//@ts-ignore
import photo from "../../assets/jobPic.webp"
import "./styles.css"
import CustomButton from '../../components/CustomButton'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useWindowSize from '../../utils/useWindowSize'

export default function Home() {

    const navigate = useNavigate()

    const { t } = useTranslation()

    const [width, _] = useWindowSize()

    const aboutUsRef = useRef<HTMLHeadingElement | null>(null);

    return (
        <div className='home'>
            <Container >
                <Navbar />
                <Row className='row-area'>
                    <h1 className='mb-2' style={{ color: "#fff", }}>{t('homeHeader1')}</h1>
                    <h2 className='mb-4' style={{ color: "#fff", fontFamily: "cursive" }}>{t('homeHeader2')}</h2>
                    <Col className='first-col' lg={6} md={12} sm={12}>
                        <h2 style={{ fontSize: width > 980 ? "36px" : "24px" }}>{t('mainPageTitle')}</h2>
                        <h3 className='mt-4' style={{ fontSize: width > 980 ? "24px" : "18px", lineHeight: width > 980 ? "36px" : "30px" }}>{t('mainPageSub')}</h3>

                        <div className='d-flex' style={{ justifyContent: width < 980 ? "center" : "" }}>
                            <CustomButton isLoading={false} className='mt-3' label={t('startButton')} onClick={() => navigate("/jobs")} />
                        </div>

                        {width < 980 && (
                            <Col className='job-col mt-4' style={{ position: "relative" }} lg={6} md={12} sm={12}>
                                <img className='job-img' src={photo} width={"100%"} height={"100%"} style={{ maxWidth: "500px", maxHeight: "500px" }} />
                            </Col>
                        )}

                        <h3 style={{ color: "#fff", textAlign: "start", paddingTop: "20px", fontWeight: "600", fontSize: width > 980 ? "24px" : "18px" }}>{t('aboutUsBtn')}</h3>
                        <div className='d-flex' style={{ justifyContent: width < 980 ? "center" : "" }}>
                            <CustomButton className='mt-3' label={t('aboutUs')} onClick={() => navigate("/about-us")} />

                        </div>

                    </Col>
                    {width > 980 && (
                        <Col className='job-col' style={{ position: "relative" }} lg={6} md={12} sm={12}>
                            <img className='job-img' src={photo} width={"100%"} height={"100%"} style={{ maxWidth: "500px", maxHeight: "500px" }} />
                        </Col>
                    )}



                </Row>

            </Container>
        </div>
    )
}
